import fb from './faqBlock.json';
import { managing_team as t } from './tips/team';
import { promoting_your_fundraiser as p } from './tips/promoting';
import { managing_donations as d } from './tips/donations';

export const cmsContent = {
  fb,
  d,
  p,
  t,
};
